import axios from 'axios'
import animateScrollTo from 'animated-scroll-to'
import concat from 'lodash/concat'

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data() {
        return {
            model: {
                showAddOptions: false,
                showContactInfo: false,
                userDomain: "ваш-сайт.рф",
                regions: "",
                format: 'ya_csv',
                protocol: 'http://',
                country: "",
                city: "",
                countryCode: "",
                cityCode: "",
                phone: "",
                addPhone: "",
                companyName: "",
                contactPerson: "",
                workTimes: [],
                address: "",
                house: "",
                build: "",
                office: "",
                email: "",
                imClient: "",
                imLogin: "",
                about: "",
                ogrn: "",
                groupLimit: 0
            },
            reportError: null,
            rest: "/export/adv_company/",
            loading: false,
            isUserDomainValid: true,
            isCountryValid: true,
            isCityValid: true,
            isCountryCodeValid: true,
            isCityCodeValid: true,
            isPhoneValid: true,
            isCompanyNameValid: true,
            isOgrnValid: true,
            isRegionValid: true,
            countries: [],
            cities: [],
            limitAboutLength: 200,
        }
    },
    props: {
        base: {
            type: String,
            required: true
        },
        domain: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.model.base = this.base;
        this.model.domain = this.domain;

        let self = this;
        axios
            .all([axios.get('/resources/countries.json'), axios.get('/resources/cities.json')])
            .then(axios.spread(function (countries, cities) {
                self.countries = countries.data;
                self.cities = cities.data;
            }));
    },
    methods: {
        preparedModel() {
            let model = JSON.parse(JSON.stringify(this.model));

            let result = {},
                pairs = [];

            model.workTimes.forEach(m => {
                let key = m.time.join("-");
                if (result.hasOwnProperty(key)) {
                    result[key] = concat(result[key], m.days).sort((a, b) => a - b);
                } else {
                    result[key] = m.days;
                }
            });

            Object.keys(result).forEach(function (key) {
                var total = result[key].reduce(function(accumulator, currentValue, index, array) {
                    if (currentValue + 1 ===  array[index + 1]) {
                        accumulator.push(currentValue);
                        return accumulator;
                    } else {
                        accumulator.push(currentValue);

                        if (accumulator.length === 1) {
                            accumulator.push(accumulator[0]);
                        } else if (accumulator.length > 2) {
                            accumulator = [accumulator[0], accumulator[accumulator.length - 1]]
                        }

                        pairs.push({
                            days: accumulator,
                            hours: key.split("-")
                        });
                        return [];
                    }

                    return currentValue;
                }, []);

            });

            if (typeof model.country === 'object') {
                model.country = model.country.display;
            }

            if (typeof model.city === 'object') {
                model.city = model.city.display;
            }

            model.workTimes = pairs;
            return model;
        },
        download() {
            let self = this,
            isValid = this.validateFields();
            self.reportError = null;
            setTimeout(()=>{
                animateScrollTo(document.querySelector('.gcontent'));
            }, 0);

            if(!isValid){
                return false;
            }

            this.loading = true;

            axios({
                method: 'post',
                url: this.getApiUrl,
                data: this.preparedModel(),
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(function (response) {

                    window.location.href = "/" + window.locale + "/adcompany/" + response.data.uid;

                    self.loading = false;

                })
                .catch(function (error) {
                    self.loading = false;
                    setTimeout(()=>{
                        animateScrollTo(document.querySelector('.adcompany'));
                    }, 0);
                    if(!error.response){
                        self.reportError = self.$t('lang.main.error.unknown_report_error');
                    }else{
                        self.reportError = error.response.data.message;
                    }
                });

        },
        validateFields(){
            let result = true;
            this.isUserDomainValid = true;
            this.isCountryValid = true;
            this.isCityValid = true;
            this.isCountryCodeValid = true;
            this.isCityCodeValid = true;
            this.isPhoneValid = true;
            this.isCompanyNameValid = true;
            this.isOgrnValid = true;
            this.isRegionValid = true;

            if(!this.isValidDomain(this.model.userDomain)){
                this.isUserDomainValid = false;
                result = false;
            }

            if(!this.model.regions){
                this.isRegionValid = false;
                result = false;
            }


            if(!this.model.showContactInfo){
                return result;
            }

            if(!this.model.country){
                this.isCountryValid = false;
                result = false;
            }

            if(!this.model.city){
                this.isCityValid = false;
                result = false;
            }

            if(!this.model.countryCode){
                this.isCountryCodeValid = false;
                result = false;
            }

            if(!this.model.cityCode){
                this.isCityCodeValid = false;
                result = false;
            }

            if(!this.model.phone){
                this.isPhoneValid = false;
                result = false;
            }

            if(!this.model.companyName){
                this.isCompanyNameValid = false;
                result = false;
            }

            if(this.model.ogrn){
                this.isOgrnValid = this.isValidOGRN(this.model.ogrn);
                if(!this.isOgrnValid){
                    result = false;
                }
            }

            return result;
        },
        isValidDomain(v) {
            if (typeof v !== 'string') return false;

            let parts = v.split('.');
            if (parts.length <= 1) return false;

            let tld = parts.pop(),
            tldRegex = /^[а-яА-ЯёЁa-zA-Z0-9]+$/gi;

            if (!tldRegex.test(tld)) return false;

            let isValid = parts.every(function(host) {
                let hostRegex = /^(?!:\/\/)([а-яА-ЯёЁa-zA-Z0-9]+|[а-яА-ЯёЁa-zA-Z0-9][а-яА-ЯёЁa-zA-Z0-9-]*[а-яА-ЯёЁa-zA-Z0-9])$/gi;

                return hostRegex.test(host);
            });

            return isValid
        },
        isValidOGRN(item){
            let ogrnLength = 13, ogrnipLength = 15, ogrnNumber = +item, ogrnString = ogrnNumber + "";

            if (ogrnString.length != ogrnLength && ogrnString.length != ogrnipLength)
                return false;

            let ogrnType = ogrnString.length == ogrnLength ? "OGRN" : "OGRNIP",
                ogrnStringLength = ogrnString.length,
                firstOgrnChar = ogrnString.substring(0, 1),
                lastOgrnChar = ogrnString.substring(ogrnStringLength - 1, ogrnStringLength),
                resultOgrnString = parseInt(ogrnString.substring(0, ogrnStringLength - 1), 10);
            if (!firstOgrnChar.match(/[1235]/))
                return false;

            let result,
                ogrnModule = resultOgrnString % ("OGRN" == ogrnType ? 11 : 13) + "";
            result = 10 > ogrnModule ? ogrnModule : ogrnModule.charAt(ogrnModule.length - 1);
            return result == lastOgrnChar;
        },
        setCountry(item) {
            this.model.country = item;
            this.model.countryCode = '+' + item.code;
        },
        setCity(event, item) {
            this.model.city = item;
            this.model.cityCode = item.code.split(" ")[0];

            if (!this.model.country) {
                this.countries.filter(i => {return i.id === item.parentId}).map(i => {
                    this.$parent.$refs.adCompanyExport.$refs.countryAutocomplete.onOptionSelect(event, i);
                })
            }
        }

    },
    computed: {
        isXlsx() {
            return this.model.format === 'ya_xlsx_new';
        },
        getApiUrl(){
            return this.$config.API_URL + this.rest + "" + this.model.format;
        },
        getCities(){
            if(this.model.country){
                return this.cities.filter(item => item.parentId === this.model.country.id);
            }

            return this.cities;
        },
        getCountries() {
            return this.countries;
        },
        aboutCharacters(){
            return this.model.about.length;
        },
        self() {
            return this;
        },
    },
}
